module.exports = __webpack_public_path__ + "img/10_ic_ladder_black_62px.fa7877fa.svg";